import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider, connect } from 'react-redux'
import { Dialog, DialogType } from '@fluentui/react/lib/Dialog'

let globalStore
let rootInstance = null

export const initWithStore = (store) => {
  globalStore = store
}

export default (
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
) => WrappedComponent => {
  const div = document.createElement('div')

  const Component = ({ title = '', minWidth = 400, onClose, children }) => (
    <Dialog
      hidden={false}
      onDismiss={onClose}
      dialogContentProps={{
        title,
        type: DialogType.normal,
        showCloseButton: true,
      }}
      modalProps={{
        isBlocking: true,
      }}
      minWidth={minWidth}
      maxWidth="100vw"
    >
      {children}
    </Dialog>
  )


  function open(props) {
    render(props)
  }

  function close() {
    destroy()
  }

  function destroy(callback = () => {}) {
    // React 18: Use root.unmount() instead of unmountComponentAtNode
    if (rootInstance) {
      rootInstance.unmount()
      rootInstance = null
    }
    if (div.parentNode) {
      div.parentNode.removeChild(div)
    }
    callback()
  }

  function render(props) {
    const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps, mergeProps)(
      innerProps => <WrappedComponent {...innerProps} {...props}/>
    )
    
    // React 18: Use createRoot instead of ReactDOM.render
    if (!rootInstance) {
      document.body.appendChild(div)
      rootInstance = createRoot(div)
    }
    
    rootInstance.render(
      <Provider store={globalStore}>
        <Component onClose={() => destroy(props.onClose)} title={props.title} minWidth={props.minWidth}>
          <ConnectedComponent />
        </Component>
      </Provider>
    )
  }

  return {
    close,
    open,
  }
}
